/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ExternalAcademicUserAddDTO
 */
export interface ExternalAcademicUserAddDTO {
	/**
	 *
	 * @type {string}
	 * @memberof ExternalAcademicUserAddDTO
	 */
	firstName?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ExternalAcademicUserAddDTO
	 */
	lastName?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ExternalAcademicUserAddDTO
	 */
	email?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof ExternalAcademicUserAddDTO
	 */
	password?: string | null;
}

export function ExternalAcademicUserAddDTOFromJSON(
	json: any
): ExternalAcademicUserAddDTO {
	return ExternalAcademicUserAddDTOFromJSONTyped(json, false);
}

export function ExternalAcademicUserAddDTOFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): ExternalAcademicUserAddDTO {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		firstName: !exists(json, "firstName") ? undefined : json["firstName"],
		lastName: !exists(json, "lastName") ? undefined : json["lastName"],
		email: !exists(json, "email") ? undefined : json["email"],
		password: !exists(json, "password") ? undefined : json["password"],
	};
}

export function ExternalAcademicUserAddDTOToJSON(
	value?: ExternalAcademicUserAddDTO | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		firstName: value.firstName,
		lastName: value.lastName,
		email: value.email,
		password: value.password,
	};
}
